{
  "welcome": {
    "title": "Hoş geldin, {{name}}",
    "title_noName": "Rhemn'e hoş geldin",
    "body": "Parlayan her şey ne işe yaradığını gösterir. İstediğin sırayla, istediğin zaman keşfet.",
    "start": "Keşfetmeye başla",
    "later": "Şimdi değil"
  },
  "card": {
    "tryIt": "Dene",
    "takeALook": "Göz at",
    "pro": "Rhemn Pro'nun bir parçası",
    "close_aria": "Kapat"
  },
  "pill": {
    "progress": "{{total}} öğeden {{count}} keşfedildi",
    "progress_short": "{{count}}/{{total}}",
    "done": "Tamam",
    "done_aria": "Keşfetmeyi bitir",
    "complete": "Hepsi keşfedildi"
  },
  "sr": {
    "started": "Keşif modu açık. Düğmeler, çalışmadan önce ne yaptıklarını gösterir.",
    "hint": "Keşif modu. Önce bunun ne yaptığını gösterir.",
    "ended": "Keşif modu kapalı."
  },
  "settings": {
    "row": "Rhemn nasıl çalışır",
    "row_sub": "Her bölüme kısa bir bakış",
    "row_aria": "Rhemn nasıl çalışır: uygulamayı yeniden keşfet",
    "helpCaption": "Yardım"
  },
  "steps": {
    "intention": {
      "title": "Bugünün niyeti",
      "body": "Bugün en önemli olan tek şeyi yaz ve bitirdiğinde işaretle."
    },
    "now": {
      "title": "Namazlarla günün",
      "body": "Rhemn gününü her namaz vaktinde böler. Burada bir sonraki namaza kalan süreyi ve o arada yapmayı planladıklarını görürsün."
    },
    "verse": {
      "title": "Ayet içgörüleri",
      "body": "Günün ayeti hakkında soru sor, kısa bir tefsir oku ve aynı konudaki ayetleri bul."
    },
    "qibla": {
      "title": "Kıble",
      "body_chrome": "Bulunduğun yerden Kâbe'nin yönü, kuzeye göre açı olarak.",
      "body_ios": "Bulunduğun yerden Kâbe'yi gösterir. Canlı pusulayı aç, sen döndükçe o da seninle döner."
    },
    "prayer": {
      "title": "Namaz vakitleri",
      "body_chrome": "Bulunduğun yer için bugünün beş vakti. Camiinin izlediği hesaplama yöntemini seç.",
      "body_ios": "Sıradaki namaz tek bakışta. Beş vaktin tamamını ve her biri için bir hatırlatıcıyı görmek için aç."
    },
    "tasks": {
      "title": "Görevler",
      "body": "Yapılacaklarını listelerde tut ve her birine namazlar arasında bir yer ver."
    },
    "notes": {
      "title": "Notlar",
      "body_chrome": "Yaz ya da sadece konuş. Rhemn sesli notlarını ve toplantılarını yazıya döker, sonra özetler.",
      "body_ios": "Yaz ya da sadece konuş. Rhemn söylediklerini düzenli, özetlenmiş notlara dönüştürür."
    },
    "profile": {
      "title_chrome": "Profilin",
      "body_chrome": "Hesap ve gizlilik ayarların. Rhemn'i yeniden keşfetmek için buraya dön.",
      "title_ios": "Daha Fazla",
      "body_ios": "Kaydedilen ayetler, Kıble ve hesap ayarların. Rhemn'i buradan yeniden keşfedebilirsin."
    }
  }
}
